var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSearchDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_294_2454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0593 6.1532C12.0593 7.16589 11.759 8.15583 11.1964 8.99783C10.6338 9.83983 9.83406 10.4961 8.89845 10.8836C7.96283 11.2711 6.93332 11.3724 5.94011 11.1748C4.9469 10.9771 4.0346 10.4894 3.3186 9.77324C2.60259 9.05709 2.11504 8.1447 1.9176 7.15145C1.72015 6.1582 1.82169 5.12871 2.20936 4.19317C2.59704 3.25763 3.25344 2.45807 4.09555 1.89559C4.93766 1.33312 5.92766 1.03301 6.94034 1.0332C8.29807 1.03347 9.60011 1.57301 10.5601 2.53317C11.52 3.49333 12.0593 4.79547 12.0593 6.1532V6.1532Z",
    stroke: "#cccccc",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3394 12.5526L10.5554 9.76855",
    stroke: "#cccccc",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_294_2454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.933,
    height: 13.933,
    fill: "white",
    transform: "translate(0.820312 0.0332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearchDark);
export default __webpack_public_path__ + "static/media/ic_search_dark.dc54868bea547c0c28c124703c19040d.svg";
export { ForwardRef as ReactComponent };